import React from 'react';
import { useNavigate } from 'react-router-dom';
import Icon from '../../../components/AppIcon';
import Image from '../../../components/AppImage';
import Button from '../../../components/ui/Button';

const RelatedContent = ({ 
  recommendations = [],
  onPlayRecommendation 
}) => {
  const navigate = useNavigate();

  return (
    <div className="related-content bg-card rounded-lg border border-border p-6">
      <h3 className="text-lg font-heading font-semibold text-foreground mb-4">
        Похожий контент
      </h3>
      <div className="recommendations-list space-y-4">
        {recommendations?.map(item => (
          <div
            key={item?.id}
            className="recommendation-item flex gap-4 p-3 rounded-lg hover:bg-muted transition-colors duration-200 cursor-pointer"
            onClick={() => navigate(`/channel-profile?id=${item?.channelId}`)}
          >
            <div className="item-artwork w-20 h-20 rounded-lg overflow-hidden flex-shrink-0">
              <Image 
                src={item?.artwork} 
                alt={item?.artworkAlt}
                className="w-full h-full object-cover"
              />
            </div>

            <div className="item-info flex-1 min-w-0">
              <h4 className="text-sm font-heading font-semibold text-foreground mb-1 line-clamp-2">
                {item?.title}
              </h4>
              <p className="text-xs text-muted-foreground mb-2 line-clamp-1">
                {item?.host}
              </p>
              <div className="item-meta flex items-center gap-3 text-xs text-muted-foreground">
                <span className="flex items-center gap-1">
                  <Icon name="Clock" size={12} color="currentColor" />
                  {item?.duration}
                </span>
                <span className="flex items-center gap-1">
                  <Icon name="Users" size={12} color="currentColor" />
                  {item?.listeners}
                </span>
              </div>
            </div>

            <Button
              variant="ghost"
              size="icon"
              onClick={(e) => {
                e?.stopPropagation();
                onPlayRecommendation(item);
              }}
              aria-label="Воспроизвести"
            >
              <Icon name="Play" size={20} color="var(--color-foreground)" />
            </Button>
          </div>
        ))}
      </div>
      <Button
        variant="outline"
        fullWidth
        className="mt-4"
        onClick={() => navigate('/search-and-discovery')}
      >
        Показать больше
      </Button>
    </div>
  );
};

export default RelatedContent;